import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthStateContext } from "../contexts/AuthStateContext";
// import KAKAOLOGINIGM from "../assets/images/kakao_login_large_narrow.png";
import KAKAOSYMBOL from "../assets/images/kakao_symbol.png";
import GOOGLESYMBOL from "../assets/images/google_symbol.png";

// import GOOGLELOGINGM from "../assets/images/ios_light_sq_SU@3x.png";
import NaverLogin from "../components/NaverLogin";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { authAxios } from "../framework/api";
import { loginTokenKey, setItem } from "../utils/localStorage";
import { CURRENTROUTE } from "../contexts/SaveDataContext";

const KAKAO_REST_API_KEY = process.env.REACT_APP_KAKAO_KEY;
const redirect_uri_kakao = `${process.env.REACT_APP_ROOT_URL}/login/kakao/redirect`;

export default function LoginPage() {
  const navigate = useNavigate();

  const { authState, handleChangeAuthState } = useContext(AuthStateContext);
  // //console.log(redirect_uri_kakao);

  const onClickKakaoLogin = () => {
    const kakaoURL = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${KAKAO_REST_API_KEY}&redirect_uri=${redirect_uri_kakao}&prompt=select_account`;
    window.location.href = kakaoURL;
  };

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await axios.get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
              Accept: "application/json",
            },
          }
        );
        if (res.status === 200) {
          //console.log(res.data.email);
          //console.log(res.data.id);
          const socialLogin = await authAxios.post(`/mobile/auth/social`, {
            type: "google",
            socialId: res.data.id,
            email: res.data.email,
          });
          //console.log(socialLogin);

          if (socialLogin.status === 201 || socialLogin.status === 200) {
            setItem(loginTokenKey, socialLogin.data);
            handleChangeAuthState(true);
            // 세션 스토리지에 저장된 sessionSaveData 정보를 가져온다.
            const sessionSaveData = sessionStorage.getItem("sessionSaveData");
            if (sessionSaveData) {
              const parsedData = JSON.parse(sessionSaveData);
              if (parsedData.route === CURRENTROUTE.DEFAULT) {
                // 파싱된 데이터를 url?파라미터로 넘겨준다.
                const { route, ...rest } = parsedData;
                console.log("메인페이지", rest);
                navigate(`/?${new URLSearchParams(rest).toString()}`);
              } else if (parsedData.route === CURRENTROUTE.COMPATIBLE) {
                // 파싱된 데이터를 url?파라미터로 넘겨준다.
                const { route, ...rest } = parsedData;
                // 성별이 여자인경우 모든 url 파라미터 앞에 언더바가 붙음.
                // ex _gender=female&_yearMonthDay=19990101&_hourMin=1234
                // 파싱된 데이터에서 성별이 여자인경우 모든 url 파라미터 앞에 언더바가 붙음.
                // 파싱된 데이터에서 성별이 남자인 경우 언더바 없이 url 파라미터로 넘겨준다.
                const { gender } = rest;
                console.log("gender", gender);
                if (gender === "FEMALE") {
                  console.log("궁합페이지 여성", rest);
                  // 값은 그대로고 파라미터 앞에 _ 추가
                  const params = Object.fromEntries(
                    Object.entries(rest).map(([key, value]) => [
                      `_${key}`,
                      value,
                    ])
                  );
                  navigate(
                    `/compatible?${new URLSearchParams(
                      params as any
                    ).toString()}`
                  );
                } else {
                  console.log("궁합페이지 남성", rest);
                  navigate(
                    `/compatible?${new URLSearchParams(rest).toString()}`
                  );
                }
              }
            } else {
              navigate("/", { replace: true });
            }
          }
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
        }
      }
    },

    onError: () => {
      //console.log("login fail");
    },
  });

  useEffect(() => {
    if (authState) {
      navigate("/", { replace: true });
    } else {
      // 세션 스토리지에 저장된 sessionSaveData 정보를 가져온다.
      const sessionSaveData = sessionStorage.getItem("sessionSaveData");
      if (sessionSaveData) {
        const parsedData = JSON.parse(sessionSaveData);
        console.log("parsedData", parsedData);
      }
    }
  }, [authState]);
  // 페이지 들어와서 한번만 갱신하게 하고 싶음.

  return (
    // <div>
    <div className="flex flex-col items-center justify-start max-w-[716px] py-2 m-auto">
      <div className="flex flex-col items-center justify-center p-2 rounded-md">
        <header className="mb-10 text-2xl font-extrabold">이규호 만세력</header>
        <div className=" w-[300px] flex flex-col items-center justify-center gap-3">
          <button
            onClick={onClickKakaoLogin}
            className="w-[180px] h-[39px] rounded-[4px] flex justify-center items-center bg-[#FEE500] text-[#000000] text-[13px] font-semibold font-[Pretendard] gap-2"
          >
            <img src={KAKAOSYMBOL} alt="kako_symbol" className="w-5" />
            <p>카카오 아이디로 로그인</p>
            {/* <img src={KAKAOLOGINIGM} alt="kakao_login_middle" /> */}
          </button>

          <NaverLogin />

          <button
            onClick={() => {
              console.log("googleLogin");
              login();
            }}
            className="w-[180px] h-[39px] rounded-[4px] bg-white border border-black flex justify-between items-center text-[#000000] text-[12px] font-semibold font-[Pretendard] px-3"
          >
            {/* <img
              className="w-[180px]"
              src={GOOGLELOGINGM}
              loading="lazy"
              alt="google logo"
            /> */}
            <img src={GOOGLESYMBOL} alt="google_symbol" className="w-5" />
            <p>Google 아이디로 로그인</p>
          </button>
        </div>
      </div>
      <div className="flex flex-col items-center border-t border-black pt-5 mt-5">
        <div className="font-semibold text-black">
          안전한 로그인을 위한 유의사항
        </div>
        <ul className="p-2 space-y-2">
          <li className="flex items-start">
            <span className="min-w-[180px] font-semibold">
              공용 컴퓨터에서의 사용:
            </span>
            <span>
              이 컴퓨터를 다른 사람과 공유한다면, 작업이 끝난 후 반드시
              '로그아웃'을 해주세요. 그렇지 않으면, 개인 정보가 다음 사용자에게
              노출될 수 있습니다.
            </span>
          </li>
          <li className="flex items-start">
            <span className="min-w-[180px] font-semibold">
              개인 컴퓨터에서의 사용:
            </span>
            <span>
              개인 컴퓨터에서도 브라우저나 탭을 닫기 전에 '로그아웃'을 하는
              습관을 들이는 것이 좋습니다.
            </span>
          </li>
          <li className="flex items-start">
            <span className="min-w-[180px] font-semibold">
              컴퓨터 종료 전 확인:
            </span>
            <span>
              컴퓨터를 종료하거나 재시작하기 전에 로그아웃 했는지 확인해주세요.
            </span>
          </li>
        </ul>
      </div>
    </div>
    // </div>
  );
}

//!document.getElementById("naver-login-sdk")이면 페이지 리로드
